module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.loadingCaseForms) ? _c('v-flex', {
    staticClass: "ph16",
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": "",
      "d-inline-flex": ""
    }
  }, [_vm._v("\n      I,\n    ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "d-inline-flex": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "Name",
      "rules": _vm.nameRules
    },
    model: {
      value: (_vm.localClientFormData.name),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "name", $$v)
      },
      expression: "localClientFormData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": "",
      "d-inline-flex": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "NRIC/FIN Number",
      "rules": _vm.nricFinNumberRules
    },
    model: {
      value: (_vm.localClientFormData.nric_fin_number),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "nric_fin_number", $$v)
      },
      expression: "localClientFormData.nric_fin_number"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-inline-flex": ""
    }
  }, [_vm._v("\n      have acknowledged receipt of and accepted the above mentioned Service Agreement that outlines the terms and\n      conditions of the services provided, and hereby authorise “Direct Funeral Services Pte Ltd” to bill myself based\n      on the above information provided.\n    ")]), _c('br'), _c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-inline-flex": ""
    }
  }, [_vm._v("\n      I acknowledge that our funeral director has shown and clearly explained the terms and conditions of products and services. In addition, I confirm that I have fully understood and agree to the terms and conditions stated above.\n    ")]), _c('br'), _c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "Contact Number",
      "rules": _vm.contactNumberRules
    },
    model: {
      value: (_vm.localClientFormData.contact_number),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "contact_number", $$v)
      },
      expression: "localClientFormData.contact_number"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "Email",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.localClientFormData.email),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "email", $$v)
      },
      expression: "localClientFormData.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "Mailing address",
      "rules": _vm.mailingAddressRules
    },
    model: {
      value: (_vm.localClientFormData.mailing_address),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "mailing_address", $$v)
      },
      expression: "localClientFormData.mailing_address"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Mailing Address same as per Deceased's Address"
    },
    model: {
      value: (_vm.localClientFormData.mailing_address_same),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "mailing_address_same", $$v)
      },
      expression: "localClientFormData.mailing_address_same"
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba2d0d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DfsServiceAgreementClientData.vue
// module id = 990
// module chunks = 1